import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import EditOutlined from '@ant-design/icons/lib/icons/EditOutlined'
import { baseAxiosComplete } from '../../../tool/axios'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}

interface Prop {
    data?: Client,
    status: string,
    onChange?: () => void
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (props: Prop) {

    const param: { id: string } = useParams()
    const [clientVisible, setVClientVisible] = useState<boolean>(false)
    const [clientForm] = useForm()

    const changeClientInfo = (values: any) => {
        baseAxiosComplete.post('/keeper/check_in/detail/update_customer_info', {
            check_in_id: param.id,
            check_in_user_name: values.check_in_user_name,
            check_in_phone: values.check_in_phone,
            preg_status: values.preg_status,
            expect_born_day: values.expect_born_day.format('YYYY-MM-DD'),
            actually_born_day: values.actually_born_day.format('YYYY-MM-DD'),
            accompany_man_name: values.accompany_man_name,
            accompany_phone: values.accompany_phone,
            emergency_man_name: values.emergency_man_name,
            emergency_phone: values.emergency_phone
        }).then(res => {
            if (res.status === 0) {
                if (props.onChange) props.onChange()
                setVClientVisible(false)
            }
        })
    }

    return (<div className="modules">
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 编辑客户信息 */}
        <Modal title="编辑客户信息" visible={clientVisible} onCancel={() => { setVClientVisible(false) }} footer={false}>
            <Form  {...formItemLayout} form={clientForm} onFinish={changeClientInfo} >
                <Form.Item required label="入住人" name="check_in_user_name" >
                    <Input />
                </Form.Item>
                <Form.Item required label="入住人手机号" name="check_in_phone" >
                    <Input />
                </Form.Item>
                <Form.Item label="怀孕时期" name="preg_status">
                    <Select>
                        <Option key={1} value={1}>正在备孕</Option>
                        <Option key={2} value={2}>已经怀孕</Option>
                        <Option key={3} value={3}>已有宝宝</Option>
                        <Option key={4} value={4}>小月子</Option>
                        <Option key={5} value={5}>孕早期</Option>
                        <Option key={6} value={6}>孕中期</Option>
                        <Option key={7} value={7}>孕晚期</Option>
                        <Option key={8} value={8}>预产期前7天</Option>
                        <Option key={9} value={9}>已分娩</Option>
                        <Option key={10} value={10}>超出预产期</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="预产期" name="expect_born_day">
                    <DatePicker />
                </Form.Item>
                <Form.Item label="分娩日" name="actually_born_day">
                    <DatePicker />
                </Form.Item>

                <Form.Item label="陪护人" name="accompany_man_name" >
                    <Input />
                </Form.Item>
                <Form.Item label="陪护人手机号" name="accompany_phone">
                    <Input />
                </Form.Item>
                <Form.Item label="紧急联系人" name="emergency_man_name" >
                    <Input />
                </Form.Item>
                <Form.Item label="紧急联系人手机号" name="emergency_phone" >
                    <Input />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        <div className="top clear" style={{ marginBottom: 20 }}>
            <h3 className="fl">
                <span className="fl">客户信息</span>
                <span className="fl waitstatus">{props.status}</span>
            </h3>

            <div className="fr editbtn" onClick={() => {
                clientForm.setFieldsValue({
                    check_in_user_name: props.data?.check_in_user_name,
                    check_in_phone: props.data?.check_in_phone,
                    accompany_man_name: props.data?.accompany_man_name,
                    accompany_phone: props.data?.accompany_phone,
                    emergency_man_name: props.data?.emergency_man_name,
                    emergency_phone: props.data?.emergency_phone
                })
                setVClientVisible(true)
            }}>
                <EditOutlined style={{ marginRight: 10 }} />
                编辑客户信息
            </div>
        </div>

        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 客户信息 */}
        <div className="content" >
            <Row style={{ width: '100%', marginTop: 15 }}>
                <Col span={6} >
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>客人姓名：</p>
                            <p className="right-text">{props.data?.check_in_user_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>手机号码：</p>
                            <p className="right-text">{props.data?.check_in_phone || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>怀孕时期：</p>
                            <p className="right-text">{props.data?.preg_status_desc || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预产期/分娩日：</p>
                            <p className="right-text">{props.data?.expect_born_day} / {props.data?.actually_born_day || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>实际入住日期：</p>
                            <p className="right-text">{props.data?.check_in_time || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预计出所日期：</p>
                            <p className="right-text">{props.data?.check_out_time_init || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>实际出所日期：</p>
                            <p className="right-text">{props.data?.check_out_time_finally || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>陪护人：</p>
                            <p className="right-text">{props.data?.accompany_man_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>陪护人手机：</p>
                            <p className="right-text">{props.data?.accompany_phone || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>紧急联系人：</p>
                            <p className="right-text">{props.data?.emergency_man_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>紧急联系人手机：</p>
                            <p className="right-text">{props.data?.emergency_phone || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预住总天数：</p>
                            <p className="right-text">{props.data?.check_in_total_days || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>已入住天数：</p>
                            <p className="right-text">{props.data?.check_in_already_days || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>剩余天数：</p>
                            <p className="right-text">{props.data?.check_in_left_days || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    </div>)
}